import React from 'react'
import SearchNav from '../../SearchNav/SearchNav'

const Scan = () => {
  return (
    <div>
        <SearchNav/>
        <h1 className='p-3'>Scan</h1>
    </div>
  )
}

export default Scan